import { SxStyles } from '../../types';
import theme from '../../theme';
import { getResponsiveSize } from '../../utils';

export const ContolPanelTaskTabStyles: SxStyles = {
  tasksContainer: {
    height: '100%',
    width: '100%',
  },
};
